import {
  IconButtonProps,
  IconButton,
  TooltipProps,
  Tooltip,
  IconButtonTypeMap,
  ExtendButtonBaseTypeMap,
  IconButtonClassKey,
  ExtendButtonBase,
} from "@material-ui/core";
import React, { ElementType } from "react";

export type TooltipIconButtonTypeMap<
  // eslint-disable-next-line @typescript-eslint/ban-types
  P = {},
  D extends React.ElementType = "button"
> = ExtendButtonBaseTypeMap<{
  props: IconButtonTypeMap<P, D>["props"] & {
    TooltipProps?: TooltipProps;
    tooltip: string;
  };
  defaultComponent: D;
  classKey: IconButtonClassKey;
}>;

const TooltipIconButton: ExtendButtonBase<TooltipIconButtonTypeMap> = ({
  tooltip,
  TooltipProps,
  onClick,
  ...other
}: {
  tooltip: string;
  TooltipProps?: TooltipProps;
} & IconButtonProps<ElementType>) => {
  const [open, setOpen] = React.useState(false);

  React.useEffect(() => {
    if (other.disabled) {
      setOpen(false);
    }
  }, [other.disabled]);

  return (
    <Tooltip
      disableFocusListener
      title={tooltip}
      enterDelay={350}
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      {...TooltipProps}
    >
      <IconButton
        {...other}
        onClick={(e) => {
          setOpen(false);
          onClick?.(e);
        }}
      />
    </Tooltip>
  );
};

export default TooltipIconButton;
